/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AuthStore, OneSignalLoaderService } from '@shared';
import { ScreenSpinnerComponent } from '@shared';
import { LocalStorageService } from '@shared';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, TranslateModule, ScreenSpinnerComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'admin';

  private _oneSignalService = inject(OneSignalLoaderService);

  constructor(
    private _translate: TranslateService,
    private _store: Store,
    private _localStorageService: LocalStorageService
  ) {
    const storedLang = this._localStorageService.getItem('language');
    this._translate.setDefaultLang(storedLang || 'es');
    this._translate.use(storedLang || 'es');
    this._store.dispatch(AuthStore.actions.tryAutoLogin());

    this._oneSignalService.setAppIdCatalog(environment.onesignal);
    this._oneSignalService.initialize()?.then(() => {
      //this._oneSignalService.requestPushPermission();
    });
  }
}
